// excelOperations.js
import { readSpreadsheet } from './spreadsheetReader';

const defaultCalculationSettings = {
  klasorPuani: 1,
  kalinDosyaPuani: 2,
  dosyaPuani: 0.5,
  sanikPuani: 1,
  magdurPuani: 1,
  hakimKendiDosyasiCarpani: 1.5,
};

export const readExcelFile = (file, progressCallback, columnMappings = {}) =>
  readSpreadsheet(file, {
    progressCallback,
    columnMappings,
    filterEmpty: true,
    maxHeaderScan: 5,
    readOptions: { raw: true },
  });

export const calculateFileScore = (file, settings = defaultCalculationSettings) => {
  let klasorSayisi = 0;
  let kalinDosyaSayisi = 0;
  let dosyaSayisi = 0;

  const klasorRegex = /(\d+)?(KD|K|D)/g;
  let match;
  while ((match = klasorRegex.exec(file.klasorSayisi)) !== null) {
    const sayi = match[1] ? parseInt(match[1]) : 1;
    const kod = match[2];

    if (kod === 'KD') {
      kalinDosyaSayisi += sayi;
    } else if (kod === 'K') {
      klasorSayisi += sayi;
    } else if (kod === 'D') {
      dosyaSayisi += sayi;
    }
  }

  // Eğer hiçbir eşleşme bulunamazsa, varsayılan olarak normal dosya sayısını 1 olarak al
  if (klasorSayisi === 0 && kalinDosyaSayisi === 0 && dosyaSayisi === 0) {
    dosyaSayisi = 1;
  }

  const faraziKlasorSayisi =
    klasorSayisi * settings.klasorPuani +
    kalinDosyaSayisi * settings.kalinDosyaPuani +
    dosyaSayisi * settings.dosyaPuani;

  const faraziDosyaSayisi = Math.ceil((file.sanikSayisi + file.magdurSayisi) / 4);

  const dosyaPuani =
    file.sanikSayisi * settings.sanikPuani +
    file.magdurSayisi * settings.magdurPuani +
    faraziKlasorSayisi;

  return {
    ...file,
    faraziKlasorSayisi: faraziKlasorSayisi || 2,
    faraziDosyaSayisi: faraziDosyaSayisi || 1,
    dosyaPuani,
    hakimKendiDosyasiPuani: dosyaPuani * settings.hakimKendiDosyasiCarpani,
  };
};

export const applyColumnMappings = (data, mappings, settings = defaultCalculationSettings) => {
  return data.map(row => {
    const mappedRow = {};
    for (const [key, mappedColumn] of Object.entries(mappings)) {
      if (mappedColumn && row.hasOwnProperty(mappedColumn)) {
        mappedRow[key] = row[mappedColumn];
      } else {
        mappedRow[key] = row[key];
      }
    }
    return calculateFileScore(mappedRow, settings);
  });
};
